import styled from '@emotion/styled';
import { spacing, color } from '@lightspeed/cirrus-tokens/utils';
import CardSection from '@lightspeed/cirrus-card/Section';

export const FormCardSection = styled(CardSection, props => ({ noSpacing: props.noSpacing }))`
  display: flex;
  flex-direction: row;
`;

export const RefNumNotes = styled('div')`
  width: 58.333%;
  display: flex;
  flex-direction: column;
  padding: ${spacing(3)} ${spacing(2)};
  border-right: solid 1px ${color('gray-100')};
`;

export const CostSummary = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: ${spacing(3)} ${spacing(2)};
  flex: 1;
`;
